"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTable = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableMixin = require("../../mixins/components/TableMixin");
var StyledTable = /*#__PURE__*/_styledComponents.default.table.withConfig({
  displayName: "StyledTable",
  componentId: "c11n-8-107-0__sc-11t7upb-0"
})(["", ""], _TableMixin.TableMixin);
exports.StyledTable = StyledTable;